import { ChangeDetectionStrategy, Component, OnInit, ViewChild, Injectable, Inject, PLATFORM_ID  } from '@angular/core';
import { RouterLink }          from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { ImageSize, Gallery, GalleryRef, GalleryItem, GalleryComponent, ImageItem, YoutubeItem } from '@ngx-gallery/core';
import { Lightbox } from '@ngx-gallery/lightbox';


@Component({
    selector: 'screenshots',
    templateUrl: './screenshots.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreenshotsComponent implements OnInit {
    items: GalleryItem[] = [];
    lightboxGalleryRef: any;
    isLightBoxOpen=false;


    constructor(public gallery: Gallery, @Inject(PLATFORM_ID) private platform: any, public lightbox: Lightbox) {}

    ngOnInit() {
        if (isPlatformBrowser(this.platform)) {
            this.items = [
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-3.jpg', thumb: 'assets/screenshots/1600x900-EN-3_thumb.jpg' }),
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-4.jpg', thumb: 'assets/screenshots/1600x900-EN-4_thumb.jpg' }),
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-5.jpg', thumb: 'assets/screenshots/1600x900-EN-5_thumb.jpg' }),
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-6.jpg', thumb: 'assets/screenshots/1600x900-EN-6_thumb.jpg' }),
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-7.jpg', thumb: 'assets/screenshots/1600x900-EN-7_thumb.jpg' }),
                new ImageItem({ src: 'assets/screenshots/1600x900-EN-8.jpg', thumb: 'assets/screenshots/1600x900-EN-8_thumb.jpg' })
            ];

            this.lightboxGalleryRef = this.gallery.ref('screenshotLightbox');
            this.lightboxGalleryRef.load(this.items);
            this.lightbox.opened.subscribe((id) => {
                if(id == 'screenshotLightbox') {
                    this.isLightBoxOpen = true;
                    this.lightboxGalleryRef.setConfig({
                        imageSize: 'contain',
                        nav: true,
                    });
                }
            });
            this.lightbox.closed.subscribe((id) => {
                if(id == 'screenshotLightbox') {
                    this.isLightBoxOpen = false;
                    this.lightboxGalleryRef.setConfig({
                        imageSize: 'cover',
                        nav: false
                    });
                }
            });
            this.lightboxGalleryRef.itemClick.subscribe((click) => {
                if(!this.isLightBoxOpen) {
                    this.lightbox.open(click, 'screenshotLightbox', {panelClass: 'fullscreen'});
                }
            });
        }
    }

    showPrev(): any {
        this.lightboxGalleryRef.prev();
    }

    showNext(): any {
        this.lightboxGalleryRef.next();
    }

}
